// components/InjectUtmLinks.js
import useUtmTags from '@hooks/useUtmTags';
import { useRouter } from 'next/router';
import { useEffect } from 'react'

const TARGET_PATHS = ['/demo', '/contact']

const phpUrlEncode = (str) => {
    return encodeURIComponent(str).replace(/%20/g, '+')
}

const appendUtmToUrl = (href, currentPath, linkText) => {
    try {
        const url = new URL(href, window.location.origin);

        // Skip non-target paths
        if (!TARGET_PATHS.includes(url.pathname)) return href;

        const page = currentPath.substring(currentPath.lastIndexOf('/') + 1)

        const utmParams = {
            utm_source: page ? 'site' : 'main',
            utm_medium: 'page',
            utm_campaign: 'link',
            utm_content: currentPath,
            utm_term: linkText
        }

        // Add only UTM params that are not already present
        Object.entries(utmParams).forEach(([key, value]) => {
            if (!url.searchParams.has(key)) {
                url.searchParams.set(key, value);
            }
        });

        return url.pathname + url.search + url.hash;
    } catch {
        return href;
    }
}

const UtmTagsInjector = () => {
    const router = useRouter();

    useEffect(() => {
        const links = document.querySelectorAll('a[href]')
        const currentPath = window.location.pathname

        links.forEach((link) => {
            const href = link.getAttribute('href')

            if (!href) return

            const linkText = link.textContent || ''
            const newHref = appendUtmToUrl(href, currentPath, linkText)

            if (newHref !== href) {
                link.setAttribute('href', newHref)
            }
        })
    }, [router])

    return null
}

export default UtmTagsInjector
